import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseFormComponent } from '../components/abstract/base/base-form.component';

/**
 * 防止頁面在開啟 Dialog 時，又按下瀏覽器的上一頁，會導致 Dialog 仍然開啟，但原頁面被換掉的問題。
 */
@Injectable({
  providedIn: 'root'
})
export class WindowPopstateGuard<T extends BaseFormComponent> {

  canDeactivate(
    component: T,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    console.log('WindowPopstateGuard currentRoute = %s,  dialogOpened = %s', currentRoute.url, component.dialogOpened);

    return !component.dialogOpened;
  }
}
